// extracted by mini-css-extract-plugin
module.exports = {"pageBackground":"styles_pageBackground__Ov9hi","formWrapper":"styles_formWrapper__2AJc_"};